export const definedMasks:any = {
    TreasureMapType1_part12: {
        p: "A3PM0IgIpEIgek9IgqgUIhsoSIAahAIJUhmIgmAgICfgNIg1geIFxgrIgNArICxgrIAegNIHbBsIhIAlID9AYIArAUIAAgUIHQB5IATAUIBaAMIh+AwIEegRIJUB7IggAoIBmAAIgbBmIAAAnIh3CLIlJOdg",
        x: 380,
        y: 464
    },
    TreasureMapType1_part11: {
        p: "ASURtIgHgxIgvgHIAUAgIgLAXMgkwgAkIEfutICqi8IAAg5IFHngIBJgKIg5gkIAhg2IDWA2Ii4hOIC1lhIBDgSIOJhCIBvAwIDcgyIgMEWIgsgGIA0AaIAWFdIABBEIhvgPIBwAlIAAA1IgxAPIAyAAIAEC+IgKASIgBARQgDAVgFAUQgFAUgLAdQgIAWgEAHIAAABIABABIAUARIANgXIAUAMIgcBkIAWAAIAFEOIgyAAIA8A8IASDXQAEAkAHAZIhOBFIBOghIAABmQACAeAOAkIhKAyIAAABIgcASIBqgRIAGBAIgdgJIAfAcIAGBBg",
        x: 631,
        y: 440
    },
    TreasureMapType1_part10: {
        p: "AlAHyIAWgsIg/AUIvNjgIARghIDxmEIAkATIAKhVIBfh+IBog9IARgfIg5gSIAoghICbADIiAhBIBWiZIHPCrIA6AAIE3B7IBagCIATBRIDGBNIAUAAIgUgoIBWBAIArgTIEoBrIgLA3IAjgXIBVAQIgyCBIBkiBIBrA1IDfBMIlyJVIgvAHIAVAdQg2AYheAZQg7ARgzAEIgmABg",
        x: 469,
        y: 349
    },
    TreasureMapType1_part9: {
        p: "AsjLxIC1hLIizAXIjMufIAxAAIgHgVID4geIA1jLIAlAHIgNgeIgYgKIAYhMIBqAjIhQhFIAti1IN/DKIHtC9IC5AsIgnAnIAiARIhXCKIgHAqIgxBKIA7AMIhgBAIh5CnIgwAxIg0BhIjRE4IllAMIgiAjIsbB0g",
        x: 291,
        y: 310
    },
    TreasureMapType1_part8: {
        p: "ArzTwIgagNIgDANIhtgCIAQg1IBAguIhAAPIgyAGIAFgvIAhgfIBEAPIhEhJIgZgKIAJhuIAShUIAnhYIgnATIgJgLQAGiCAAhxICyAFIiyg4QgBhngDhEIgBgNIAFhRIAAkCIAcgIIAyAZIg9hEIgBhsQgBhDgMigIgLiTIAYkpIAcgUIgeAAIgOgxQgJgegNhiIgNhbIAjABIAAA/IAkBZIgDiLIBfAnIBTg0IRBh3IALAVIAhABIBmF3Ig5A/IA5gRIAnCQIhYC6IBNhPIALBnIg1AjIBngHICOPQICNMKg",
        x: 141,
        y: 417
    },
    TreasureMapType1_part7: {
        p: "AmCNUIAAgkIgzAkImH5vIASgnIAAgXIHwANIFUC0IBmBuIg6CgIBtiMID2CIIABABIBdAzIBBA6IDcBgQADCKgBAWQgCAwAEBMIgXBOIAAAFIAUgGIAMgNIAMAFIgNFHIgZAJIANAUIgPAhIAcDFIgBANInyA4Ig0gfInZBJg",
        x: 662,
        y: 244
    },
    TreasureMapType1_part6: {
        p: "AItO3IgtAbIvuluIgrhSIhaASIhLgnIBlheIhlAmIAAhDIAcgVIAOg7IgqAAIAqnwIAhhaIgFhjIAUg1IB1iJIhOgjIgchkIgMhTIATjbIJDA3IFOAEIBxH1IgKAdIgEAyIgkAAIBNCZICCHJIAvFnIA6CCIAJB3IgcAAIhWCcg",
        x: 543,
        y: 249
    },
    TreasureMapType1_part5: {
        p: "AIcMaIrWkVIAWhCIhCBCIhAgqImiiTIhchKIBOiSIAbgUIgbg1IAygQIBWj9IAAhAIBKjLIA4AAIgdgkIA6j8IJxgEIC8A+IFnAeIgcEsIAkBkIAAA8IA4gDIhzCLIg8J5IAAEKg",
        x: 408,
        y: 217
    },
    TreasureMapType1_part4: {
        p: "AtUGiIhBgTIAAgBQgCijANhDQAIgqgGhrIgHhgIAHhOIA7AAICshCIAeAvIAXhZIQ0msIAXAdIApAYIB4AVIBzEPIgTBRIAoBUIAAhSIAdgCIBxDuIh2HEIgtASIAfBEIlfjBIERDRIj8AYIoKAmIhuAnIqdBAg",
        x: 140,
        y: 229
    },
    TreasureMapType1_part3: {
        p: "ADuLHIAAghIgqAAIkpijIAAgoIgUA1Qg1gmjFiCIi7h6IAAmXIA+AAIhhgvIgDgtIANgPIAAj4IgjgzIgIiSIAKhIIAWhNIBEgCQBKgDAbgGQAsgJB7gLIBMAAIAHA6IA2geIA+gEQBPgEBbACQCSADEWgLIAjAZIgsA8IA9gmIAoCkIgBAxQgNAVgFALIgVA6IAagVIALASIgDCbIgWgWIAGAsIgoAxIgMBEQgHBSATBCQAeBpAKAbIgZF9IghAAIAfASIgLAxIiAgbICbA9IgDC3IhcB5IAAACIA6g6IACCKgAGmjCIgGADIgBABQgFADgHAIIgBABIgFAHQgJAOgFARQgGAQACAMIAJAyIAGATIAAABIACAGIAAAAIAFAMIABABIACAEIAAABIADAEIAAABIADAEIABABIAFAGIABAAIADACIABAAIADABIABAAIADABIABAAIADgBIABAAIAEgBQAagKALghQAKgcgFgQQgIgdgLgbQgVgzgOAAIgDAAg",
        x: 686,
        y: 134
    },
    TreasureMapType1_part2: {
        p: "AJ9IdIgQAAIgggcIgciSIAACmIoGg+Ii3gcIiqAAIjEhGIpTAAIAkkGIAZgKIAAhVImcn/IgIgXIAJAAIACgXIElAAIgPAoIAWABICFgpIGjAAIDrA5IhDgkIAegVIF8AAIgOAkIBCgkIJYAAIAMA8IAcgRIALgrIAKATIA6AyICHBLIgehIIBLgEIAAAfIAUgOICgg9ICVgCQAbAAAeAPQAOAIAKAHIAigZIAZCAIADgKIAIBqIgwAzIjbgFIEOAxIAuJ+IgxA7Ih0APIiTAIQlgARh/AAIghgBg",
        x: 483,
        y: 98
    },
    TreasureMapType1_part1: {
        p: "AiFOeIgzglIg7ABIAAhBIghAsIgfAVIkUhJIh2kbIgsARIAEhaIgkgtIhfjVIATgWIBmjWIAhANIgQgoIBkjWIBJAAIgygzIAAhEIgKglIComNQAwABAngHIAogKIABAAQAUgIAOgIQAegRAMgbQAVgugUgaQCCgDBWgHQCegMBVgIICsAAIAAAOIA9A0IAAgDIAPAVQAsBBA8BEIgSAwIAWARQAaAYAZAfQAVAbBYBXIBZBWIA5APIhfDmIg5AaIAgAsIggBLIgahLIhAhhIAjBhIARCWIkBL+IgmAAIAbAhQgLANgPAVIgSAfQgKAPgJAlQgNAsgGAxg",
        x: 293,
        y: 144
    },
    TreasureMapType1_part0: {
        p: "AtgMYIgpgGIhSgZQAXi1AAhGQAAgsgLhlIgVjOIAKgZIAcAIIgchFIgMgTIAMkPIAcgIIgggLQAEh9gCgdIgSiwIAbgeIgQgVIgNgNIAAglIA5h9IA6APIArAyIAAgxIEggQIA1CwIAAiZIDdAVQAcAEAxgCQA3gBAsgJQA/gLBUgKIAUAXIAlgDIAKgjIDRAAIAWASIA7gSIAABVIAqhVIFtAAIA5APQgnAbAYA9QAMAfAxAVQAuAUA9ADIghBKIgSASIg1CEIAAACIgiBdIg5AAIAvAdIhECZIgSAAIAeAbIg3ChIgZgTIhuEJQgUAyACAIIi0gmIhHAUQkeBxgjADQgWACgrAQIgpAPIivBRIgUgeIgXAzIjCA/IAAAAIluB1gAKnrTQgnAFgUAaIgCADIgEAGIgHANQgIAVAKAPQAIALAQAGQAPAFAsgCQAugBAIgJQAGgIADgQIACgDIAAgCIABgIIAAgEIgBgEIAAgDIAAgFIgDgHIgEgLIgIgKIgGgHIgJgGIgMgFIgRgCIgTACg",
        x: 146,
        y: 123
    }
};
